export const CaretDownIcon = (props: any) => {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="#9B9B9B" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.6921 3.36194L5.72356 7.96371C5.60997 8.09543 5.39124 8.09543 5.27644 7.96371L1.3079 3.36194C1.16047 3.19035 1.2934 2.93899 1.53146 2.93899H9.46854C9.7066 2.93899 9.83953 3.19035 9.6921 3.36194Z"/>
        </svg>
    )
}